
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

export default function Services() {
  return (
    <div className="min-h-screen">
      <Header />

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-600 to-purple-700 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-bold text-white mb-6">
            AI Agency Services &amp; Digital Growth Solutions
          </h1>
          <p className="text-xl text-blue-100 max-w-4xl mx-auto">
            As a dedicated digital growth partner, Ebusiness Marketing Group provides comprehensive suite of services designed to elevate your business&apos;s marketing, sales, and customer
            engagement through cutting‑edge automation and intelligent AI solutions.
          </p>
        </div>
      </section>

      {/* Strategic Foundation Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Strategic Foundation &amp; Implementation
            </h2>
            <p className="text-xl text-gray-600 max-w-4xl mx-auto">
              Our offerings are meticulously crafted to streamline your operations, enhance your market reach, and foster sustainable growth through intelligent automation
              and AI solutions.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-20">
            {/* Business Growth Assessment */}
            <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-8">
              <div className="w-16 h-16 bg-blue-100 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-search-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Business Growth Assessment
              </h3>
              <p className="text-gray-600 mb-6">
                We conduct thorough evaluations to understand your current marketing and sales landscape, identify challenges, and pinpoint opportunities for significant
                growth through advanced automation and AI integration.
              </p>
              <div className="space-y-3">
                <div className="flex items-start text-gray-700">
                  <i className="ri-check-line text-green-500 mr-3 mt-1"></i>
                  <div>
                    <strong>Current Landscape Analysis:</strong> Comprehensive review of existing marketing and sales processes
                  </div>
                </div>
                <div className="flex items-start text-gray-700">
                  <i className="ri-check-line text-green-500 mr-3 mt-1"></i>
                  <div>
                    <strong>Challenge Identification:</strong> Pinpoint bottlenecks and inefficiencies in your operations
                  </div>
                </div>
                <div className="flex items-start text-gray-700">
                  <i className="ri-check-line text-green-500 mr-3 mt-1"></i>
                  <div>
                    <strong>Growth Opportunities:</strong> Discover untapped potential through AI and automation
                  </div>
                </div>
                <div className="flex items-start text-gray-700">
                  <i className="ri-check-line text-green-500 mr-3 mt-1"></i>
                  <div>
                    <strong>Strategic Roadmap:</strong> Detailed plan for AI integration and growth acceleration
                  </div>
                </div>
              </div>
            </div>

            {/* Tailored Platform Setup */}
            <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl p-8">
              <div className="w-16 h-16 bg-purple-100 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-settings-3-line text-2xl text-purple-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Tailored Platform Setup
              </h3>
              <p className="text-gray-600 mb-6">
                We meticulously configure your dedicated marketing and sales platform, customizing it to align perfectly with your brand identity, operational workflows,
                and specific business objectives.
              </p>
              <div className="space-y-3">
                <div className="flex items-start text-gray-700">
                  <i className="ri-check-line text-green-500 mr-3 mt-1"></i>
                  <div>
                    <strong>Brand Alignment:</strong> Platform customization matching your brand identity and values
                  </div>
                </div>
                <div className="flex items-start text-gray-700">
                  <i className="ri-check-line text-green-500 mr-3 mt-1"></i>
                  <div>
                    <strong>Workflow Integration:</strong> Seamless alignment with your operational processes
                  </div>
                </div>
                <div className="flex items-start text-gray-700">
                  <i className="ri-check-line text-green-500 mr-3 mt-1"></i>
                  <div>
                    <strong>Infrastructure Setup:</strong> Essential technical foundation and security protocols
                  </div>
                </div>
                <div className="flex items-start text-gray-700">
                  <i className="ri-check-line text-green-500 mr-3 mt-1"></i>
                  <div>
                    <strong>Access Controls:</strong> Secure user management and permission systems
                  </div>
                </div>
              </div>
            </div>

            {/* Seamless Data Integration */}
            <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-8">
              <div className="w-16 h-16 bg-green-100 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-database-2-line text-2xl text-green-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Seamless Data Integration
              </h3>
              <p className="text-gray-600 mb-6">
                We ensure the secure and efficient transfer of your vital customer data, leads, and marketing assets into your new system, guaranteeing data integrity and a
                smooth transition without disruption.
              </p>
              <div className="space-y-3">
                <div className="flex items-start text-gray-700">
                  <i className="ri-check-line text-green-500 mr-3 mt-1"></i>
                  <div>
                    <strong>Secure Data Transfer:</strong> Protected migration of customer data and marketing assets
                  </div>
                </div>
                <div className="flex items-start text-gray-700">
                  <i className="ri-check-line text-green-500 mr-3 mt-1"></i>
                  <div>
                    <strong>Data Integrity:</strong> Complete accuracy and consistency throughout the process
                  </div>
                </div>
                <div className="flex items-start text-gray-700">
                  <i className="ri-check-line text-green-500 mr-3 mt-1"></i>
                  <div>
                    <strong>Zero Disruption:</strong> Smooth transition maintaining business continuity
                  </div>
                </div>
                <div className="flex items-start text-gray-700">
                  <i className="ri-check-line text-green-500 mr-3 mt-1"></i>
                  <div>
                    <strong>Lead Management:</strong> Comprehensive lead data organization and optimization
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Dedicated Strategic Partnership Section */}
          <div className="bg-gradient-to-br from-indigo-50 to-blue-50 rounded-2xl p-8 mb-20">
            <div className="flex items-center mb-6">
              <div className="w-16 h-16 bg-indigo-100 rounded-xl flex items-center justify-center mr-6">
                <i className="ri-handshake-line text-2xl text-indigo-600"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900">Dedicated Strategic Partnership</h3>
                <p className="text-indigo-600 font-semibold">Ongoing Success Assurance</p>
              </div>
            </div>
            <p className="text-gray-600 mb-6">
              We provide ongoing support, proactive troubleshooting, and expert strategic guidance to ensure you consistently achieve maximum return on your
              investment.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-indigo-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-customer-service-2-line text-indigo-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Ongoing Support</h4>
                <p className="text-gray-600 text-sm">Continuous assistance and guidance throughout your business journey</p>
              </div>
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-indigo-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-tools-line text-indigo-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Proactive Troubleshooting</h4>
                <p className="text-gray-600 text-sm">Identifying and resolving issues before they impact your operations</p>
              </div>
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-indigo-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-lightbulb-line text-indigo-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Expert Strategic Guidance</h4>
                <p className="text-gray-600 text-sm">Professional insights to maximize your return on investment</p>
              </div>
            </div>
          </div>

          {/* Adaptive Optimization Section */}
          <div className="bg-gradient-to-br from-emerald-50 to-teal-50 rounded-2xl p-8 mb-20">
            <div className="flex items-center mb-6">
              <div className="w-16 h-16 bg-emerald-100 rounded-xl flex items-center justify-center mr-6">
                <i className="ri-refresh-line text-2xl text-emerald-600"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900">Adaptive Optimization</h3>
                <p className="text-emerald-600 font-semibold">Continuous Performance Enhancement</p>
              </div>
            </div>
            <p className="text-gray-600 mb-6">
              We continuously review and refine your existing campaigns, automations, and AI configurations to adapt to market dynamics and evolve with your business
              objectives.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-emerald-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-line-chart-line text-emerald-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Campaign Refinement</h4>
                <p className="text-gray-600 text-sm">Continuous optimization of marketing campaigns for peak performance</p>
              </div>
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-emerald-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-settings-4-line text-emerald-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Automation Enhancement</h4>
                <p className="text-gray-600 text-sm">Regular updates to automation workflows for improved efficiency</p>
              </div>
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-emerald-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-brain-line text-emerald-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">AI Configuration Updates</h4>
                <p className="text-gray-600 text-sm">Adaptive AI model adjustments based on performance data</p>
              </div>
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-emerald-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-compass-3-line text-emerald-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Market Adaptation</h4>
                <p className="text-gray-600 text-sm">Strategic pivots to align with evolving market conditions</p>
              </div>
            </div>
          </div>

          {/* Innovation Integration Section */}
          <div className="bg-gradient-to-br from-violet-50 to-purple-50 rounded-2xl p-8 mb-20">
            <div className="flex items-center mb-6">
              <div className="w-16 h-16 bg-violet-100 rounded-xl flex items-center justify-center mr-6">
                <i className="ri-lightbulb-flash-line text-2xl text-violet-600"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900">Innovation Integration</h3>
                <p className="text-violet-600 font-semibold">Cutting-Edge Technology Adoption</p>
              </div>
            </div>
            <p className="text-gray-600 mb-6">
              We keep you informed about the latest platform advancements and AI innovations, helping you seamlessly integrate these new capabilities into your growth strategies.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-violet-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-rocket-line text-violet-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Latest Platform Updates</h4>
                <p className="text-gray-600 text-sm">Stay ahead with cutting‑edge platform features and capabilities</p>
              </div>
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-violet-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-cpu-line text-violet-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">AI Innovation Tracking</h4>
                <p className="text-gray-600 text-sm">Monitor and evaluate emerging AI technologies for business impact</p>
              </div>
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-violet-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-puzzle-line text-violet-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Seamless Integration</h4>
                <p className="text-gray-600 text-sm">Smooth implementation of new technologies into existing workflows</p>
              </div>
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-violet-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-arrow-up-line text-violet-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Strategic Growth Enhancement</h4>
                <p className="text-gray-600 text-sm">Leverage innovations to accelerate business growth and competitive advantage</p>
              </div>
            </div>
          </div>

          {/* Intelligent Content Creation Section */}
          <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl p-8 mb-20">
            <div className="flex items-center mb-6">
              <div className="w-16 h-16 bg-orange-100 rounded-xl flex items-center justify-center mr-6">
                <i className="ri-quill-pen-line text-2xl text-orange-600"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900">Intelligent Content Creation</h3>
                <p className="text-orange-600 font-semibold">AI-Powered Content Strategy</p>
              </div>
            </div>
            <p className="text-gray-600 mb-6">
              We implement and strategize the use of advanced AI for generating compelling and high-quality content across all your channels. This includes crafting engaging website copy,
              dynamic blog posts, effective social media updates, and persuasive email campaigns. We will guide you on maximizing AI&apos;s potential for brand‑consistent messaging.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-brain-line text-xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">AI Strategy Consulting</h3>
                <p className="text-gray-600 mb-4">
                  Guiding businesses on AI adoption and integration into marketing workflows with strategic planning and implementation roadmaps.
                </p>
                <ul className="space-y-2 text-sm text-gray-600">
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-500 mr-2"></i>AI Readiness Assessment
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-500 mr-2"></i>Implementation Strategy
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-500 mr-2"></i>Technology Integration Planning
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-500 mr-2"></i>Performance Measurement Framework
                  </li>
                </ul>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
                <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-robot-line text-xl text-purple-600"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">AI Implementation &amp; Training</h3>
                <p className="text-gray-600 mb-4">
                  Comprehensive setup, configuration, and team training for AI tools to ensure seamless adoption and maximum utilization.
                </p>
                <ul className="space-y-2 text-sm text-gray-600">
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-500 mr-2"></i>Custom AI Model Development
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-500 mr-2"></i>Integration with Existing Systems
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-500 mr-2"></i>Staff Training and Enablement
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-500 mr-2"></i>Ongoing Support and Optimization
                  </li>
                </ul>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
                <div className="w-12 h-12 bg-amber-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-line-chart-line text-xl text-amber-600"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">AI Performance Analytics</h3>
                <p className="text-gray-600 mb-4">
                  Advanced data analysis and reporting to track AI implementation success and optimize marketing performance.
                </p>
                <ul className="space-y-2 text-sm text-gray-600">
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-500 mr-2"></i>Real‑Time Performance Monitoring
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-500 mr-2"></i>ROI and Impact Analysis
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-500 mr-2"></i>Predictive Analytics Modeling
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-500 mr-2"></i>Custom Dashboard Development
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Automated Reputation Management Section */}
          <div className="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-2xl p-8 mb-20">
            <div className="flex items-center mb-6">
              <div className="w-16 h-16 bg-teal-100 rounded-xl flex items-center justify-center mr-6">
                <i className="ri-shield-star-line text-2xl text-teal-600"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900">Automated Reputation Management</h3>
                <p className="text-teal-600 font-semibold">AI-Driven Online Presence</p>
              </div>
            </div>
            <p className="text-gray-600 mb-6">
              We establish and fine‑tune systems for managing your online reputation. This involves automating the process of gathering customer feedback,
              suggesting thoughtful responses, and employing autopilot features to maintain and enhance your positive presence across review platforms.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              {/* Feedback Collection */}
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-feedback-line text-teal-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Feedback Collection</h4>
                <p className="text-gray-600 text-sm">
                  Automated systems to gather customer reviews and feedback across platforms
                </p>
              </div>

              {/* Response Suggestions */}
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-chat-smile-3-line text-teal-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Response Suggestions</h4>
                <p className="text-gray-600 text-sm">
                  AI‑generated thoughtful responses to maintain professional communication
                </p>
              </div>

              {/* Autopilot Features */}
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-flight-takeoff-line text-teal-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Autopilot Features</h4>
                <p className="text-gray-600 text-sm">
                  Automated reputation monitoring and maintenance across all review platforms
                </p>
              </div>

              {/* Reputation Monitoring (fixed missing card) */}
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-eye-line text-teal-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Reputation Monitoring</h4>
                <p className="text-gray-600 text-sm">
                  Continuous tracking of brand sentiment and online mentions
                </p>
              </div>
            </div>
          </div>

          {/* Conversational AI for Engagement Section */}
          <div className="bg-gradient-to-br from-indigo-50 to-purple-50 rounded-2xl p-8 mb-20">
            <div className="flex items-center mb-6">
              <div className="w-16 h-16 bg-indigo-100 rounded-xl flex items-center justify-center mr-6">
                <i className="ri-chat-4-line text-2xl text-indigo-600"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900">Conversational AI for Engagement</h3>
                <p className="text-indigo-600 font-semibold">Intelligent Customer Interaction</p>
              </div>
            </div>
            <p className="text-gray-600 mb-6">
              We design, train, and deploy sophisticated AI‑driven chatbots to handle common customer inquiries, answer frequently asked questions, and efficiently schedule
              appointments. These solutions are built to deliver highly personalized and effective customer interactions, freeing up your team&apos;s time.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-indigo-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-question-answer-line text-indigo-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Customer Inquiries</h4>
                <p className="text-gray-600 text-sm">Intelligent handling of common questions and support requests 24/7</p>
              </div>
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-indigo-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-book-open-line text-indigo-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">FAQ Automation</h4>
                <p className="text-gray-600 text-sm">Comprehensive knowledge base integration for instant accurate responses</p>
              </div>
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-indigo-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-calendar-check-line text-indigo-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Appointment Scheduling</h4>
                <p className="text-gray-600 text-sm">Seamless calendar integration for automated booking and scheduling</p>
              </div>
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-indigo-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-user-heart-line text-indigo-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Personalized Interactions</h4>
                <p className="text-gray-600 text-sm">Tailored responses based on customer history and preferences</p>
              </div>
            </div>
          </div>

          {/* Streamlined Workflow Automation Section */}
          <div className="bg-gradient-to-br from-rose-50 to-pink-50 rounded-2xl p-8 mb-20">
            <div className="flex items-center mb-6">
              <div className="w-16 h-16 bg-rose-100 rounded-xl flex items-center justify-center mr-6">
                <i className="ri-flow-chart text-2xl text-rose-600"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900">Streamlined Workflow Automation</h3>
                <p className="text-rose-600 font-semibold">Advanced Process Optimization</p>
              </div>
            </div>
            <p className="text-gray-600 mb-6">
              We develop and implement intricate automation sequences to optimize complex business processes. This spans everything from nurturing leads and managing sales pipelines to
              onboarding new customers and providing ongoing support. We can also integrate specialized AI models for advanced functionalities like sentiment analysis,
              personalized follow‑ups, and dynamic content generation, tailoring these advanced tools to your specific needs.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-rose-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-seedling-line text-rose-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Lead Nurturing</h4>
                <p className="text-gray-600 text-sm">Automated sequences for converting prospects into qualified leads</p>
              </div>
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-rose-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-line-chart-line text-rose-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Sales Pipeline Management</h4>
                <p className="text-gray-600 text-sm">Intelligent tracking and optimization of sales opportunities</p>
              </div>
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-rose-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-user-add-line text-rose-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Customer Onboarding</h4>
                <p className="text-gray-600 text-sm">Seamless automated processes for new customer integration</p>
              </div>
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-rose-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-heart-pulse-line text-rose-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Sentiment Analysis</h4>
                <p className="text-gray-600 text-sm">AI‑powered emotional intelligence for personalized communications</p>
              </div>
            </div>
          </div>

          {/* High‑Converting Funnel Development Section */}
          <div className="bg-gradient-to-br from-violet-50 to-purple-50 rounded-2xl p-8 mb-20">
            <div className="flex items-center mb-6">
              <div className="w-16 h-16 bg-violet-100 rounded-xl flex items-center justify-center mr-6">
                <i className="ri-funnel-line text-2xl text-violet-600"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900">High‑Converting Funnel Development</h3>
                <p className="text-violet-600 font-semibold">Conversion Optimization Excellence</p>
              </div>
            </div>
            <p className="text-gray-600 mb-6">
              We construct and optimize effective sales funnels, encompassing engaging landing pages, user‑friendly forms, insightful surveys, and automated follow‑up sequences,
              all designed to maximize conversions.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-violet-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-pages-line text-violet-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Landing Pages</h4>
                <p className="text-gray-600 text-sm">Engaging, conversion‑focused pages that capture and convert visitors</p>
              </div>
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-violet-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-file-list-3-line text-violet-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">User‑Friendly Forms</h4>
                <p className="text-gray-600 text-sm">Optimized forms that maximize completion rates and data quality</p>
              </div>
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-violet-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-survey-line text-violet-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Insightful Surveys</h4>
                <p className="text-gray-600 text-sm">Strategic surveys that gather valuable customer insights and preferences</p>
              </div>
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-violet-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-repeat-line text-violet-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Follow‑up Sequences</h4>
                <p className="text-gray-600 text-sm">Automated nurturing sequences that guide prospects to conversion</p>
              </div>
            </div>
          </div>

          {/* Targeted Email &amp; SMS Campaigns Section */}
          <div className="bg-gradient-to-br from-amber-50 to-yellow-50 rounded-2xl p-8 mb-20">
            <div className="flex items-center mb-6">
              <div className="w-16 h-16 bg-amber-100 rounded-xl flex items-center justify-center mr-6">
                <i className="ri-mail-send-line text-2xl text-amber-600"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900">Targeted Email &amp; SMS Campaigns</h3>
                <p className="text-amber-600 font-semibold">Strategic Communication Excellence</p>
              </div>
            </div>
            <p className="text-gray-600 mb-6">
              We create and manage strategic email and SMS marketing campaigns, leveraging powerful automation capabilities for lead nurturing, promotional broadcasts, and
              critical transactional communications.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-amber-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-seedling-line text-amber-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Lead Nurturing</h4>
                <p className="text-gray-600 text-sm">Automated sequences that guide prospects through the sales journey</p>
              </div>
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-amber-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-megaphone-line text-amber-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Promotional Broadcasts</h4>
                <p className="text-gray-600 text-sm">Strategic campaigns that drive engagement and boost sales</p>
              </div>
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-amber-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-exchange-line text-amber-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Transactional Communications</h4>
                <p className="text-gray-600 text-sm">Critical automated messages for orders, confirmations, and updates</p>
              </div>
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-amber-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-smartphone-line text-amber-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">SMS Marketing</h4>
                <p className="text-gray-600 text-sm">Direct mobile messaging for time‑sensitive offers and alerts</p>
              </div>
            </div>
          </div>

          {/* Integrated Social Media Strategy Section */}
          <div className="bg-gradient-to-br from-pink-50 to-rose-50 rounded-2xl p-8 mb-20">
            <div className="flex items-center mb-6">
              <div className="w-16 h-16 bg-pink-100 rounded-xl flex items-center justify-center mr-6">
                <i className="ri-share-circle-line text-2xl text-pink-600"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900">Integrated Social Media Strategy</h3>
                <p className="text-pink-600 font-semibold">Comprehensive Social Presence Management</p>
              </div>
            </div>
            <p className="text-gray-600 mb-6">
              We manage and integrate your social media presence for direct content publishing, real‑time monitoring, and automated engagement, significantly boosting your brand&apos;s
              visibility and interaction with your audience.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-pink-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-edit-box-line text-pink-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Direct Content Publishing</h4>
                <p className="text-gray-600 text-sm">Automated content distribution across multiple social platforms</p>
              </div>
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-pink-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-radar-line text-pink-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Real‑Time Monitoring</h4>
                <p className="text-gray-600 text-sm">Continuous tracking of brand mentions and audience engagement</p>
              </div>
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-pink-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-chat-smile-2-line text-pink-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Automated Engagement</h4>
                <p className="text-gray-600 text-sm">Intelligent responses and interactions to maintain active presence</p>
              </div>
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-pink-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-eye-line text-pink-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Brand Visibility Boost</h4>
                <p className="text-gray-600 text-sm">Strategic optimization for maximum reach and audience interaction</p>
              </div>
            </div>
          </div>

          {/* Professional Web &amp; Funnel Design Section */}
          <div className="bg-gradient-to-br from-cyan-50 to-blue-50 rounded-2xl p-8 mb-20">
            <div className="flex items-center mb-6">
              <div className="w-16 h-16 bg-cyan-100 rounded-xl flex items-center justify-center mr-6">
                <i className="ri-layout-line text-2xl text-cyan-600"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900">Professional Web &amp; Funnel Design</h3>
                <p className="text-cyan-600 font-semibold">Conversion‑Optimized Digital Experiences</p>
              </div>
            </div>
            <p className="text-gray-600 mb-6">
              We develop professional, responsive websites and landing pages that are specifically optimized for capturing leads and converting visitors into loyal customers.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-cyan-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-smartphone-line text-cyan-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Responsive Design</h4>
                <p className="text-gray-600 text-sm">Mobile‑optimized websites that perform flawlessly across all devices</p>
              </div>
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-cyan-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-target-line text-cyan-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Lead Capture Optimization</h4>
                <p className="text-gray-600 text-sm">Strategic placement of forms and CTAs to maximize visitor conversions</p>
              </div>
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-cyan-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-speed-line text-cyan-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Performance Optimization</h4>
                <p className="text-gray-600 text-sm">Fast‑loading pages with superior user experience and SEO benefits</p>
              </div>
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-cyan-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-heart-line text-cyan-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Customer‑Centric Design</h4>
                <p className="text-gray-600 text-sm">User‑focused interfaces that guide visitors toward desired actions</p>
              </div>
            </div>
          </div>

          {/* Client Relationship Management (CRM) Section */}
          <div className="bg-gradient-to-br from-emerald-50 to-teal-50 rounded-2xl p-8 mb-20">
            <div className="flex items-center mb-6">
              <div className="w-16 h-16 bg-emerald-100 rounded-xl flex items-center justify-center mr-6">
                <i className="ri-contacts-line text-2xl text-emerald-600"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900">Client Relationship Management (CRM)</h3>
                <p className="text-emerald-600 font-semibold">Comprehensive Customer Intelligence</p>
              </div>
            </div>
            <p className="text-gray-600 mb-6">
              We implement and oversee a robust CRM system to meticulously track leads, monitor all customer interactions, and efficiently manage sales opportunities, ensuring
              no potential business is overlooked.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-emerald-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-user-search-line text-emerald-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Lead Tracking</h4>
                <p className="text-gray-600 text-sm">Comprehensive monitoring of prospects from initial contact to conversion</p>
              </div>
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-emerald-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-chat-history-line text-emerald-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Interaction Monitoring</h4>
                <p className="text-gray-600 text-sm">Complete history of customer communications across all touchpoints</p>
              </div>
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-emerald-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-trophy-line text-emerald-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Sales Opportunity Management</h4>
                <p className="text-gray-600 text-sm">Efficient pipeline management to maximize conversion rates</p>
              </div>
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-emerald-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-shield-check-line text-emerald-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Zero Business Loss</h4>
                <p className="text-gray-600 text-sm">Systematic approach ensuring no potential opportunities are missed</p>
              </div>
            </div>
          </div>

          {/* Empowerment Through Training Section */}
          <div className="bg-gradient-to-br from-sky-50 to-blue-50 rounded-2xl p-8 mb-20">
            <div className="flex items-center mb-6">
              <div className="w-16 h-16 bg-sky-100 rounded-xl flex items-center justify-center mr-6">
                <i className="ri-graduation-cap-line text-2xl text-sky-600"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900">Empowerment Through Training</h3>
                <p className="text-sky-600 font-semibold">Comprehensive Team Development</p>
              </div>
            </div>
            <p className="text-gray-600 mb-6">
              We offer comprehensive training programs for you and your team, ensuring you are proficient in utilizing all aspects of your marketing and sales platform and its
              integrated AI capabilities.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-sky-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-book-open-line text-sky-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Platform Mastery</h4>
                <p className="text-gray-600 text-sm">Complete training on all marketing and sales platform features and capabilities</p>
              </div>
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-sky-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-robot-line text-sky-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">AI Integration Training</h4>
                <p className="text-gray-600 text-sm">Hands‑on instruction for leveraging AI tools and automation features</p>
              </div>
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-sky-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-team-line text-sky-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Team Development</h4>
                <p className="text-gray-600 text-sm">Customized training sessions for different team roles and responsibilities</p>
              </div>
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-sky-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-support-line text-sky-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Ongoing Support</h4>
                <p className="text-gray-600 text-sm">Continuous learning resources and expert guidance for sustained success</p>
              </div>
            </div>
          </div>

          {/* Performance Analytics & Reporting Section */}
          <div className="bg-gradient-to-br from-slate-50 to-gray-50 rounded-2xl p-8 mb-20">
            <div className="flex items-center mb-6">
              <div className="w-16 h-16 bg-slate-100 rounded-xl flex items-center justify-center mr-6">
                <i className="ri-bar-chart-box-line text-2xl text-slate-600"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900">Performance Analytics &amp; Reporting</h3>
                <p className="text-slate-600 font-semibold">Data‑Driven Business Intelligence</p>
              </div>
            </div>
            <p className="text-gray-600 mb-6">
              We provide detailed reports and insightful analytics on your marketing campaign performance, sales pipeline health, and overall business growth. These insights
              are crucial for informed decision‑making and continuous strategic refinement.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-slate-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-line-chart-line text-slate-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Campaign Performance</h4>
                <p className="text-gray-600 text-sm">Comprehensive analysis of marketing campaign effectiveness and ROI</p>
              </div>
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-slate-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-pulse-line text-slate-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Sales Pipeline Health</h4>
                <p className="text-gray-600 text-sm">Real‑time monitoring of sales funnel performance and conversion rates</p>
              </div>
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-slate-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-growth-line text-slate-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Business Growth Metrics</h4>
                <p className="text-gray-600 text-sm">Key performance indicators tracking overall business expansion</p>
              </div>
              <div className="bg-white rounded-lg p-4">
                <div className="w-10 h-10 bg-slate-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-lightbulb-line text-slate-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Strategic Insights</h4>
                <p className="text-gray-600 text-sm">Actionable recommendations for continuous improvement and optimization</p>
              </div>
            </div>
          </div>

          {/* Main AI Services */}
          <section className="py-20 bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center mb-16">
                <h2 className="text-4xl font-bold text-gray-900 mb-4">
                  Comprehensive AI Agency Services
                </h2>
                <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                  Cutting‑edge artificial intelligence solutions designed to transform your marketing strategies and drive measurable business growth.
                </p>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-20">
                {/* AI Agency Services */}
                <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-8">
                  <div className="flex items-center mb-6">
                    <div className="w-16 h-16 bg-blue-100 rounded-xl flex items-center justify-center mr-4">
                      <i className="ri-robot-line text-2xl text-blue-600"></i>
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold text-gray-900">AI‑Powered Marketing Solutions</h3>
                      <p className="text-blue-600 font-semibold">Custom Pricing</p>
                    </div>
                  </div>
                  <p className="text-gray-600 mb-6">
                    Leverage cutting‑edge artificial intelligence to transform your marketing strategies, optimize campaigns, and deliver personalized customer
                    experiences that drive results.
                  </p>
                  <div className="space-y-4 mb-8">
                    <div className="bg-white rounded-lg p-4">
                      <h4 className="font-semibold text-gray-900 mb-2">AI‑Powered Analytics &amp; Insights</h4>
                      <p className="text-gray-600 text-sm">Deep market data analysis and consumer behavior insights</p>
                    </div>
                    <div className="bg-white rounded-lg p-4">
                      <h4 className="font-semibold text-gray-900 mb-2">Automated Marketing Optimization</h4>
                      <p className="text-gray-600 text-sm">Real‑time campaign optimization and ad spend efficiency</p>
                    </div>
                    <div className="bg-white rounded-lg p-4">
                      <h4 className="font-semibold text-gray-900 mb-2">Personalized Customer Experiences</h4>
                      <p className="text-gray-600 text-sm">Dynamic content and tailored communication strategies</p>
                    </div>
                    <div className="bg-white rounded-lg p-4">
                      <h4 className="font-semibold text-gray-900 mb-2">Predictive Modeling &amp; Forecasting</h4>
                      <p className="text-gray-600 text-sm">Market trend prediction and demand forecasting</p>
                    </div>
                  </div>
                  <Button href="/contact" variant="primary" className="w-full whitespace-nowrap">
                    Explore AI Solutions
                  </Button>
                </div>

                {/* Business Development & DBA Services */}
                <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-8">
                  <div className="flex items-center mb-6">
                    <div className="w-16 h-16 bg-green-100 rounded-xl flex items-center justify-center mr-4">
                      <i className="ri-building-line text-2xl text-green-600"></i>
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold text-gray-900">Business Development &amp; DBA Services</h3>
                      <p className="text-green-600 font-semibold">Starting at $1,500</p>
                    </div>
                  </div>
                  <p className="text-gray-600 mb-6">
                    Comprehensive support for establishing and growing new business entities with expert guidance, legal compliance, strategic planning, and ongoing advisory
                    services.
                  </p>
                  <div className="space-y-4 mb-8">
                    <div className="bg-white rounded-lg p-4">
                      <h4 className="font-semibold text-gray-900 mb-2">Comprehensive Business Development</h4>
                      <p className="text-gray-600 text-sm">Complete LLC, Corporation, and DBA establishment with legal compliance</p>
                    </div>
                    <div className="bg-white rounded-lg p-4">
                      <h4 className="font-semibold text-gray-900 mb-2">Legal &amp; Compliance Consultation</h4>
                      <p className="text-gray-600 text-sm">Optimal legal structures, name registration, and regulatory compliance guidance</p>
                    </div>
                    <div className="bg-white rounded-lg p-4">
                      <h4 className="font-semibold text-gray-900 mb-2">Documentation &amp; Filing Management</h4>
                      <p className="text-gray-600 text-sm">All necessary state and federal paperwork preparation and submission</p>
                    </div>
                    <div className="bg-white rounded-lg p-4">
                      <h4 className="font-semibold text-gray-900 mb-2">Strategic Planning for New Ventures</h4>
                      <p className="text-gray-600 text-sm">Market entry strategies, business model development, and operational setup</p>
                    </div>
                    <div className="bg-white rounded-lg p-4">
                      <h4 className="font-semibold text-gray-900 mb-2">Ongoing Advisory Services</h4>
                      <p className="text-gray-600 text-sm">Support for early‑stage challenges, marketing strategies, and growth planning</p>
                    </div>
                  </div>
                  <Button href="/contact" variant="primary" className="w-full whitespace-nowrap">
                    Start Your Business
                  </Button>
                </div>
              </div>
            </div>
          </section>

          {/* Additional AI Services Section */}
          <section className="py-20 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center mb-16">
                <h2 className="text-4xl font-bold text-gray-900 mb-4">
                  Additional AI Marketing Solutions
                </h2>
                <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                  Comprehensive AI services designed to revolutionize your marketing approach and drive measurable results.
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-brain-line text-xl text-blue-600"></i>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">AI Strategy Consulting</h3>
                  <p className="text-gray-600 mb-4">
                    Guiding businesses on AI adoption and integration into marketing workflows with strategic planning and implementation roadmaps.
                  </p>
                  <ul className="space-y-2 text-sm text-gray-600">
                    <li className="flex items-center">
                      <i className="ri-check-line text-green-500 mr-2"></i>AI Readiness Assessment
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-green-500 mr-2"></i>Implementation Strategy
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-green-500 mr-2"></i>Technology Integration Planning
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-green-500 mr-2"></i>Performance Measurement Framework
                    </li>
                  </ul>
                </div>

                <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
                  <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-robot-line text-xl text-purple-600"></i>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">AI Implementation &amp; Training</h3>
                  <p className="text-gray-600 mb-4">
                    Comprehensive setup, configuration, and team training for AI tools to ensure seamless adoption and maximum utilization.
                  </p>
                  <ul className="space-y-2 text-sm text-gray-600">
                    <li className="flex items-center">
                      <i className="ri-check-line text-green-500 mr-2"></i>Custom AI Model Development
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-green-500 mr-2"></i>Integration with Existing Systems
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-green-500 mr-2"></i>Staff Training and Enablement
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-green-500 mr-2"></i>Ongoing Support and Optimization
                    </li>
                  </ul>
                </div>

                <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
                  <div className="w-12 h-12 bg-amber-100 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-line-chart-line text-xl text-amber-600"></i>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">AI Performance Analytics</h3>
                  <p className="text-gray-600 mb-4">
                    Advanced data analysis and reporting to track AI implementation success and optimize marketing performance.
                  </p>
                  <ul className="space-y-2 text-sm text-gray-600">
                    <li className="flex items-center">
                      <i className="ri-check-line text-green-500 mr-2"></i>Real‑Time Performance Monitoring
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-green-500 mr-2"></i>ROI and Impact Analysis
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-green-500 mr-2"></i>Predictive Analytics Modeling
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-green-500 mr-2"></i>Custom Dashboard Development
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          {/* VistaBoost Success Story */}
          <section className="py-20 bg-gradient-to-br from-blue-50 to-indigo-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center mb-16">
                <h2 className="text-4xl font-bold text-gray-900 mb-4">VistaBoost Success Story</h2>
                <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                  See how our AI‑powered marketing solutions delivered remarkable results for VistaBoost
                </p>
              </div>

              <div className="bg-white rounded-2xl p-8 md:p-12 shadow-lg">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                  <div>
                    <div className="bg-gradient-to-r from-blue-500 to-purple-600 text-white text-sm font-semibold px-4 py-1 rounded-full inline-block mb-4">
                      Case Study
                    </div>
                    <h3 className="text-3xl font-bold text-gray-900 mb-6">
                      How VistaBoost Transformed Their Marketing with AI
                    </h3>
                    <p className="text-gray-600 mb-6">
                      VistaBoost, specializing in digital marketing for medical practices, partnered with us to enhance their client acquisition process. Through
                      strategic AI implementation, we revolutionized their marketing approach.
                    </p>
                    <div className="grid grid-cols-2 gap-6 mb-8">
                      <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-4">
                        <div className="text-3xl font-bold text-blue-600 mb-1">40%</div>
                        <div className="text-gray-700 font-medium">Lead Conversion Increase</div>
                      </div>
                      <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-xl p-4">
                        <div className="text-3xl font-bold text-purple-600 mb-1">60%</div>
                        <div className="text-gray-700 font-medium">Time Efficiency Gains</div>
                      </div>
                    </div>
                    <Button href="/case-studies" variant="primary">
                      View Full Case Study
                    </Button>
                  </div>

                  <div className="bg-gray-100 rounded-xl p-8 flex items-center justify-center">
                    <div className="text-center">
                      <div className="text-6xl mb-4">📊</div>
                      <p className="text-gray-600 italic">
                        &quot;The AI implementation exceeded our expectations, delivering measurable results in lead generation and conversion rates while
                        significantly reducing our marketing team&apos;s workload.&quot;
                      </p>
                      <div className="mt-6">
                        <div className="font-semibold text-gray-900">Sarah Johnson</div>
                        <div className="text-gray-600">Marketing Director, VistaBoost</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Process Section */}
          <section className="py-20 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center mb-16">
                <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Process &amp; Implementation</h2>
                <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                  Streamlined approach to seamlessly integrate AI solutions into your business operations
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                <div className="text-center">
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                    <span className="text-2xl font-bold text-blue-600">1</span>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">Discovery &amp; Assessment</h3>
                  <p className="text-gray-600">
                    We conduct a comprehensive analysis of your current marketing landscape and identify AI opportunities
                  </p>
                </div>

                <div className="text-center">
                  <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6">
                    <span className="text-2xl font-bold text-purple-600">2</span>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">Strategy &amp; Planning</h3>
                  <p className="text-gray-600">
                    Custom AI roadmap development tailored to your business objectives and operational workflows
                  </p>
                </div>

                <div className="text-center">
                  <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
                    <span className="text-2xl font-bold text-amber-600">3</span>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">Implementation &amp; Training</h3>
                  <p className="text-gray-600">
                    Seamless AI deployment with comprehensive team training and system integration
                  </p>
                </div>

                <div className="text-center">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                    <span className="text-2xl font-bold text-green-600">4</span>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">Optimization &amp; Growth</h3>
                  <p className="text-gray-600">
                    Continuous performance monitoring and AI refinement for sustained business growth
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section className="py-20 bg-gradient-to-r from-blue-600 to-purple-700">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
              <h2 className="text-4xl font-bold text-white mb-6">
                Ready to Transform Your Business with AI?
              </h2>
              <p className="text-xl text-blue-100 max-w-3xl mx-auto mb-10">
                Schedule a consultation today to discover how our AI solutions can drive growth, efficiency, and competitive advantage for your business.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button href="/contact" variant="light" className="px-8 py-4 text-lg">
                  Book a Consultation
                </Button>
                <Button
                  href="/services"
                  variant="outline"
                  className="px-8 py-4 text-lg text-white border-white hover:bg-white hover:text-blue-600"
                >
                  View All Services
                </Button>
              </div>
            </div>
          </section>

          {/* FAQ Section */}
          <section className="py-20 bg-white">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center mb-16">
                <h2 className="text-4xl font-bold text-gray-900 mb-4">
                  Frequently Asked Questions About Our Services
                </h2>
                <p className="text-xl text-gray-600">
                  Get detailed answers about our AI agency services and business development solutions
                </p>
              </div>

              <div className="space-y-6" itemScope itemType="https://schema.org/FAQPage">
                <div className="bg-gray-50 rounded-xl p-6 shadow-sm" itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
                  <h3 className="text-lg font-semibold text-gray-900 mb-3" itemProp="name">
                    What specific AI technologies do you implement in your marketing solutions?
                  </h3>
                  <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                    <p className="text-gray-600" itemProp="text">
                      We implement advanced machine learning algorithms, natural language processing for content creation, predictive analytics for customer behavior modeling, computer vision for visual content optimization, and deep learning neural networks for personalization. Our AI stack includes automated A/B testing, sentiment analysis, chatbot development, and real-time campaign optimization that continuously learns from your data to improve performance.
                    </p>
                  </div>
                </div>

                <div className="bg-gray-50 rounded-xl p-6 shadow-sm" itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
                  <h3 className="text-lg font-semibold text-gray-900 mb-3" itemProp="name">
                    How does your Business Growth Assessment identify specific opportunities?
                  </h3>
                  <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                    <p className="text-gray-600" itemProp="text">
                      Our Business Growth Assessment uses AI-powered analytics to analyze your current marketing funnel, customer journey mapping, competitor analysis, and market positioning. We examine conversion rates at each touchpoint, identify bottlenecks in your sales process, analyze customer lifetime value patterns, and benchmark your performance against industry standards. This comprehensive analysis reveals untapped opportunities for automation, personalization, and growth acceleration.
                    </p>
                  </div>
                </div>

                <div className="bg-gray-50 rounded-xl p-6 shadow-sm" itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
                  <h3 className="text-lg font-semibold text-gray-900 mb-3" itemProp="name">
                    What makes your Conversational AI different from standard chatbots?
                  </h3>
                  <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                    <p className="text-gray-600" itemProp="text">
                      Our Conversational AI uses advanced natural language understanding, contextual memory, and personalized response generation based on customer history and preferences. Unlike basic chatbots with scripted responses, our AI learns from each interaction, handles complex multi-turn conversations, integrates with your CRM and calendar systems, and can perform sophisticated tasks like appointment scheduling, lead qualification, and personalized product recommendations while maintaining your brand voice.
                    </p>
                  </div>
                </div>

                <div className="bg-gray-50 rounded-xl p-6 shadow-sm" itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
                  <h3 className="text-lg font-semibold text-gray-900 mb-3" itemProp="name">
                    How do you ensure data security during the Seamless Data Integration process?
                  </h3>
                  <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                    <p className="text-gray-600" itemProp="text">
                      We implement enterprise-grade security protocols including end-to-end encryption, secure API connections, multi-factor authentication, and compliance with GDPR, CCPA, and HIPAA standards where applicable. Our data migration process uses encrypted channels, creates secure backups, implements role-based access controls, and includes comprehensive audit trails. All data transfers are monitored in real-time with automatic rollback capabilities to ensure zero data loss or corruption.
                    </p>
                  </div>
                </div>

                <div className="bg-gray-50 rounded-xl p-6 shadow-sm" itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
                  <h3 className="text-lg font-semibold text-gray-900 mb-3" itemProp="name">
                    What specific metrics do you track in Performance Analytics & Reporting?
                  </h3>
                  <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                    <p className="text-gray-600" itemProp="text">
                      We track comprehensive KPIs including lead generation rates, conversion funnel performance, customer acquisition costs, lifetime value, engagement metrics, campaign ROI, AI model accuracy, automation efficiency, and revenue attribution. Our dashboards provide real-time insights into email open rates, click-through rates, social media engagement, website behavior, sales pipeline velocity, and predictive forecasting. All metrics are customizable based on your specific business objectives and industry benchmarks.
                    </p>
                  </div>
                </div>

                <div className="bg-gray-50 rounded-xl p-6 shadow-sm" itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
                  <h3 className="text-lg font-semibold text-gray-900 mb-3" itemProp="name">
                    How does your Automated Reputation Management handle negative reviews?
                  </h3>
                  <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                    <p className="text-gray-600" itemProp="text">
                      Our AI system monitors all review platforms 24/7, immediately alerts you to negative feedback, and suggests personalized response strategies based on sentiment analysis and context. The system categorizes issues, tracks resolution patterns, and provides templates for professional responses. It also identifies opportunities to encourage positive reviews from satisfied customers, monitors competitor reviews for market insights, and generates reports showing reputation trends and improvement recommendations.
                    </p>
                  </div>
                </div>

                <div className="bg-gray-50 rounded-xl p-6 shadow-sm" itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
                  <h3 className="text-lg font-semibold text-gray-900 mb-3" itemProp="name">
                    What does the Streamlined Workflow Automation include for lead nurturing?
                  </h3>
                  <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                    <p className="text-gray-600" itemProp="text">
                      Our lead nurturing automation includes intelligent lead scoring, personalized email sequences, behavioral trigger campaigns, dynamic content delivery, and multi-channel follow-ups. The system tracks engagement patterns, adjusts messaging frequency, segments leads based on interests and behavior, integrates with your CRM for seamless handoffs to sales, and uses predictive analytics to identify the optimal time and channel for each touchpoint to maximize conversion probability.
                    </p>
                  </div>
                </div>

                <div className="bg-gray-50 rounded-xl p-6 shadow-sm" itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
                  <h3 className="text-lg font-semibold text-gray-900 mb-3" itemProp="name">
                    How comprehensive is your Business Development & DBA service package?
                  </h3>
                  <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                    <p className="text-gray-600" itemProp="text">
                      Our comprehensive package includes complete business entity formation (LLC, Corporation, or DBA), EIN acquisition, state and federal registration, operating agreement drafting, compliance setup, business banking guidance, initial marketing strategy development, brand identity creation, website development, and ongoing advisory services. We handle all legal paperwork, provide strategic planning consultations, and offer 6 months of business development support to ensure successful launch and early growth.
                    </p>
                  </div>
                </div>

                <div className="bg-gray-50 rounded-xl p-6 shadow-sm" itemScope itemProp="mainEntity" itemType="https://schema.org/Answer">
                  <h3 className="text-lg font-semibold text-gray-900 mb-3" itemProp="name">
                    What training and support do you provide for team empowerment?
                  </h3>
                  <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                    <p className="text-gray-600" itemProp="text">
                      We provide comprehensive training including live workshops, video tutorials, hands‑on practice sessions, and certification programs. Training covers platform navigation, AI tool utilization, campaign creation, analytics interpretation, and best practices. We offer role-specific training for different team members, ongoing support through dedicated account managers, monthly check-ins, access to our knowledge base, and priority technical support to ensure your team maximizes the platform&apos;s potential.
                    </p>
                  </div>
                </div>

                <div className="bg-gray-50 rounded-xl p-6 shadow-sm" itemScope itemProp="mainEntity" itemType="https://schema.org/Answer">
                  <h3 className="text-lg font-semibold text-gray-900 mb-3" itemProp="name">
                    How do you measure success and ROI for your AI implementations?
                  </h3>
                  <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                    <p className="text-gray-600" itemProp="text">
                      We establish baseline metrics before implementation, then track improvements in lead generation, conversion rates, customer acquisition costs, revenue growth, and operational efficiency. Success is measured through increased automation efficiency, reduced manual workload, improved customer satisfaction scores, higher engagement rates, and direct revenue attribution. We provide monthly ROI reports showing cost savings, revenue increases, and productivity gains, typically demonstrating 300‑500% ROI within 6‑12 months.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>

      <Footer />
    </div>
  );
}
